export default __webpack_public_path__ + "static/media/Data-Science-Venn-Diagram-Drew-Conway.06dc76fb.png";